<template>
    <div>
        <div v-if="model">
            <rkm-form
                ref="RkmForm"
            >
                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-input-autocomplete
                            :disabled="disableField()"
                            :repository="repositories.material"
                            :request-query-string-params="queryStringParams.material"
                            :search-fields="fields.autocomplete.material"
                            :validations="validations.material"
                            label="Item"
                            text-field="descricaoCompleta"
                            v-model="model.item.material"
                        />
                    </rkm-col>
                </rkm-row>
                
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-input
                            :value="model.item.estoque"
                            disabled
                            label="Estoque"
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-button
                                    :disabled="!model.item.material"
                                    @click.stop="loadEstoque"
                                    color="primary"
                                    title="Atualizar estoque"
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="sync-alt" />
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            :disabled="!model.item.material || this.model.item.estoque == 0"
                            :max-date="form.dataAtual"
                            label="Data da dispensação"
                            right
                            v-model="model.item.dispensadoEm"
                            :validations="validations.dispensadoEm"
                        />
                    </rkm-col>
                    <rkm-col cols="4">
                        <rkm-form-input
                            :disabled="disableField() || !model.item.material || this.model.item.estoque == 0"
                            :validations="validations.quantidade"
                            label="Quantidade"
                            type="number"
                            v-model="model.item.quantidade"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-textarea
                            :disabled="!model.item.material || this.model.item.estoque == 0"
                            :validations="validations.observacao"
                            label="Observações"
                            v-model="model.item.observacao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col class="text-right">
                        <rkm-button
                            :label="false"
                            @click="save()"
                            color="primary"
                            class="mt-0"
                            :disabled="this.model.item.estoque == 0"
                        >
                            Incluir
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            class="mt-0"
                            @click.stop="resetMaterial"
                            :disabled="!model.item.material"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </div>
    </div>
</template>

<script>
import { repository, object, error } from '@/mixins'
import { mapActions } from 'vuex'

export default {
    created() {
        this.repositories = {
            material: this.getConectaSusRepository('cadastro.material'),
            dispensacaoMaterial: this.getConectaSusRepository('almoxarifado.dispensacaoMaterial')
        }
    },
    computed: {
        lotes() {
            if (!this.model.item.material || !this.model.item.possuiEntradaComLote) return []
            return this.model.item.entradaItens.filter(l => parseInt(l.quantidadeSaida) > 0)
        },
        fields() {
            return {
                autocomplete: {
                    material: [
                        { key: "codigo_material", searchable: true },
                        { key: "descricao", searchable: true },
                    ],
                },
                lotes: [
                    { key: "lote", label: "Lote" },
                    { key: "validadeLote", label: "Validade" },
                    { key: "quantidadeSaida", label: "Quantidade" },
                ]
            }
        },
        queryStringParams() {
            return {
                material: {
                    almoxarifado_check_dispensacao_materiais: true,
                    almoxarifado_check_controle_estoque: true
                }
            }
        },
        validations() {
            return {
                material: { required: true },
                dispensadoEm: { required: true },
                quantidade: { required: true, min_value: 1, min: 1, max_value: this.model.item.estoque, max: this.model.item.estoque },
                entregue: { required: true, min_value: 1, min: 1 },
                observacao: { min:3, max: 300 },
            }
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        disableField() {
            return this.model && this.model.item && Number(this.model.item.id) > 0
        },
        handlePermission(supervisorId){
            this.model.item.supervisorId = supervisorId
            this.loadEstoque()
        },
        resetMaterial() {
            this.model.item.material = null
            this.model.item.dispensadoEm = null
            this.model.item.quantidade = null
            this.model.item.observacao = null
            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (!valid) return
                    this.$emit('save', this.model.item)
                    this.$refs.RkmForm.resetValidator()
                })
        },
        loadEstoque() {
            this.model.item.possuiEntradaComLote = false
            this.model.item.estoque = 0
            this.model.item.entradaItens = []
            this.model.item.escolheuEntradaItemManualmente = false
            this.setLoading()
            this.repositories.material.getEstoque(this.model.item.material.id, this.form.centroCustoId)
                .then(({ data }) => {
                    this.model.item.possuiEntradaComLote = data.possuiEntradaComLote
                    this.model.item.estoque = data.total
                    this.model.item.entradaItens = data.porEntrada.map(estoqueEntrada => {
                        estoqueEntrada.quantidadeSaida = 0
                        return estoqueEntrada
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    watch: {
        'model.item.material'(material) {
            if(!this.model) return
            this.model.item.estoque = 0
            this.model.item.entradaItens = []
            this.model.item.escolheuEntradaItemManualmente = false
            this.model.item.entregue = null
            if(!material) return
            this.loadEstoque()
        }
    },
    mixins: [ repository, object, error ],
    props: {
        form: { type: Object, default: null },
        model: { type: Object, default: null },
    }
}
</script>